import { createOnShowAction } from './trackingDOM';
import url from './url';

import { trackEvent as omegaTrackEvent } from '@/utils/omega';

export const TECH_PAGE_MODULE_SW = 'fin_marketing_adv_page_module_sw';
export const TECH_ACTION_MODULE_CK = 'fin_marketing_adv_action_module_ck';
export const TECH_ACTION_MODULE_TYP = 'fin_marketing_adv_action_module_typ';

export const trackEventModuleSw = (module: string) => {
    return trackEvent(TECH_PAGE_MODULE_SW, {
        module
    });
};

export const trackEventModuleCk = (module: string) => {
    return trackEvent(TECH_ACTION_MODULE_CK, {
        module
    });
};

export const trackEventActionTyp = (module: string, timing: number) => {
    return trackEvent(TECH_ACTION_MODULE_TYP, {
        module,
        timing: Math.floor(timing || 0)
    });
};

export const trackEvent = (eventId: string, attrs: { [key: string]: string | number }) => {
    try {
        if (!window.Omega) {
            return Promise.reject('omega is not init');
        }

        return omegaTrackEvent(eventId, {
            page_source: window.__PAGE_CONFIG__?.pageId,
            ...window.adv?.getMediaData() || {},
            timing: Math.floor(window.performance.now()),
            ext: url.parseQuery(),
            ...attrs,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const moduleVisibleTrack = createOnShowAction((payload: { [key: string]: string }) => {
    trackEvent(TECH_PAGE_MODULE_SW, {
        ...payload,
    });
});
